import { SubscriptionTier } from "../../proto/api_pb";

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const tierStorageMap: Record<
  number,
  { storageValue: number; displayText: string }
> = {
  [SubscriptionTier.SUBSCRIPTION_TIER_PRO]: {
    displayText: "100GB",
    storageValue: 100,
  },
  [SubscriptionTier.SUBSCRIPTION_TIER_MINOR]: {
    displayText: "500GB",
    storageValue: 500,
  },
  [SubscriptionTier.SUBSCRIPTION_TIER_MAJOR]: {
    displayText: "1TB",
    storageValue: 1000,
  },
  [SubscriptionTier.SUBSCRIPTION_TIER_STUDIO]: {
    displayText: "1TB",
    storageValue: 1000,
  },
  [SubscriptionTier.SUBSCRIPTION_TIER_FREE]: {
    displayText: "5GB",
    storageValue: 5,
  },
};

export const tierMap: Record<number, string> = {
  [SubscriptionTier.SUBSCRIPTION_TIER_PRO]: "Pro",
  [SubscriptionTier.SUBSCRIPTION_TIER_MINOR]: "Minor",
  [SubscriptionTier.SUBSCRIPTION_TIER_MAJOR]: "Major",
  [SubscriptionTier.SUBSCRIPTION_TIER_STUDIO]: "Studio",
  [SubscriptionTier.SUBSCRIPTION_TIER_FREE]: "Free",
};

